import { actionLog } from 'services/actionlog.service';

/**
 * Gravações do participante sobre a própria participação, com o mesmo payload dos modais atuais
 * (`task-item/modal-actions/team-member-decrease.tsx` e `team-member-exclude.tsx`).
 * Devolvem `true` só quando a ação volta com `attributes.status === 'OK'` (RDN-14, RDN-16, RDN-17).
 */

async function registrar(acao: string, atributos: Record<string, unknown>): Promise<boolean> {
  try {
    const { action } = await actionLog('me', acao, atributos);
    return action?.attributes?.status === 'OK';
  } catch {
    return false;
  }
}

/** RDN-14: reduz o percentual de atuação de `player` na realização. */
export function reduzirParticipacao(taskId: string, percent: number, player: string): Promise<boolean> {
  return registrar('task_team_member_change_percent', { taskId, percent, player });
}

/** RDN-16: tira `player` da realização. */
export function sairDaRealizacao(taskId: string, player: string, ecoa?: boolean): Promise<boolean> {
  return registrar('task_team_member_exclude', { taskId, player, ecoa });
}
